import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./modal.scss";

const ResolveChatModal = (props) => {

    const { show, hide, classchat, title, text, btntext1, onClickPA } = props;
    return (
        <section className="as-complete-sec">
            <Modal
                show={show}
                onHide={hide}
                className={classchat}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton> </Modal.Header>
                <Modal.Body>
                    <h3>{title}</h3>
                    <p>{text}</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className=" w-100 text-center resolveModalFooter">
                        <Button variant="primary" onClick={onClickPA}>
                            {btntext1}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </section>
    );
};
export default ResolveChatModal;